export default __webpack_public_path__ + "static/media/video_vast.6f6593ee.svg";